import React from 'react';

type DataTableTableType = {
  children: React.ReactNode;
};

const DataTableTable = ({ children }: DataTableTableType): JSX.Element => {
  return (
    <div className='relative box-border flex flex-col w-full h-full max-w-full'>
      {children}
    </div>
  );
};

export default DataTableTable;
